import PreviewError from '@/../img/email-display-error.svg';
import React from 'react';
import { Button } from 'rsuite';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 600px;
`;

const ParagraphWrapper = styled.div`
  font-family: NunitoSans;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
`;

const SmallParagraphWrapper = styled.div`
  margin-bottom: 15px;
  font-family: Lato;
  font-size: 14px;
  line-height: 1.57;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);
`;

const StyledPreviewError = styled(PreviewError)`
  margin-bottom: 20px;
`;

export function EmailPreviewError(props) {
  const { setHasError, onTryAgainClick } = props;

  const handleOnClick = () => {
    setHasError(false);
    onTryAgainClick();
  };

  return (
    <Wrapper>
      <StyledPreviewError />
      <ParagraphWrapper>Something went wrong</ParagraphWrapper>
      <SmallParagraphWrapper>
        If the problem persists, let us know.
      </SmallParagraphWrapper>
      <Button css="width: 120px;" onClick={handleOnClick}>
        Try Again
      </Button>
    </Wrapper>
  );
}
